export const mainCls = 'skItem';

const baseSKColor = '#f0f2f5';
const shineSKColor = 'rgba(229,229,229,0.8)';
const animationSKDuration = '1.5s';

export default {
  [`${mainCls}`]: {
    flexShrink: 0,
    position: 'relative',
    background: baseSKColor,
    overflow: 'hidden',
    '&:before': {
      content: '""',
      display: 'block',
      position: 'absolute',
      left: 0,
      top: 0,
      height: '100%',
      width: 75,
      background: `linear-gradient(to right, ${baseSKColor} 0%, ${shineSKColor} 50%, ${baseSKColor} 100%)`,
      animation: `keyframes-load ${animationSKDuration} cubic-bezier(0.4, 0.0, 0.2, 1) infinite`,
    },
    '&.b-r--100': {
      borderRadius: '100px',
    }
  },
  '@keyframes load': {
    from: {
      transform: 'translate(-75px, 0)',
    },
    to: {
      transform: 'translate(300px, 0)',
    },
  },
};
